import { render, staticRenderFns } from "./BusLocation.vue?vue&type=template&id=2f5056a5&scoped=true&"
import script from "./BusLocation.vue?vue&type=script&lang=js&"
export * from "./BusLocation.vue?vue&type=script&lang=js&"
import style0 from "./BusLocation.vue?vue&type=style&index=0&id=2f5056a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5056a5",
  null
  
)

export default component.exports